// @core/api/endpoints/calendar/add_calendar_member.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AddCalendarMemberRequest,
  CalendarMemberResponse,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Add calendar member
 * Shares the calendar with a user or team by adding them as a member with a specified role (viewer, editor, admin).
 */
export async function AddCalendarMember(
  calendar_id: string,
  data: AddCalendarMemberRequest,
  options?: RequestOptions
): Promise<CalendarMemberResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/calendars/:calendar_id/members`;
  requestPath = requestPath.replace(':calendar_id', encodeURIComponent(calendar_id));
  const requestOptions = options;
  return client.post<CalendarMemberResponse>(requestPath, data, requestOptions);
}
